import { ProductRequestResultProduct } from '../../../../../Services/SearchProductFeedTypes';
import { ShopifyCollectionManualProductPosition } from '../../../../../Services/ShopifyManualSortingServices';

export type ShopifyCollectionWithPinnedProducts = {
	label: string;
	collectionId: string;
	pinnedProducts: PinnedShopifyProduct[]
}

export type PinnedShopifyProduct = {
	product: ProductRequestResultProduct;
	position: number;
}


export function toShopifyCollectionManualProductPosition(shopifyCollection: ShopifyCollectionWithPinnedProducts): ShopifyCollectionManualProductPosition {
	return {
		collectionId: shopifyCollection.collectionId,
		productPositions: shopifyCollection.pinnedProducts.map(p => ({
			position: p.position,
			productId: p.product.id
		}))
	};
}